import React from 'react'
import Commoninformation from '../Pagehome/Commoninformation'
import { Link } from 'react-router-dom'
import Icons from '../../components/icons';

const Privacypolicy = () => {
    return (
        <>
            {/* <Commoninformation /> */}
            <div className='container-lg'>
                {/*breadcrunb start*/}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li><span><Icons.SlashSvg /></span></li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Privacy Policy
                        </li>
                    </ol>
                </nav>
                {/*breadcrunb End*/}
            </div>
            <div className='innerpages-section padding-50'>
                <div className='container-lg'>

                    <div className='flex-box justify-center mb-4'>
                        <div className='custom-heading  text-center '>
                            Privacy Policy
                        </div>
                    </div>

                    <div className='inp-inner'>

                        <div className='custom-text ct-small'>
                            We prioritize your privacy and are committed to protecting the information you share when visiting our platform for updates and insights from across the <strong>United Kingdom</strong>.
                        </div>
                        <div className='custom-heading ch-medium'>
                            1. Information We Gather
                        </div>
                        <div className='custom-text ct-small'>
                            We may collect details such as your name, email, IP address, device type, and browsing activity. This data helps improve website performance, deliver updates, and provide a <strong>personalized UK-focused experience</strong>.
                        </div>
                        <div className='custom-heading ch-medium'>
                            2. Purpose of Collected Data
                        </div>
                        <div className='custom-text ct-small'>The information we gather is used to:</div>
                        <ul className='custom-text ct-small custom-list'>
                            <li>Customize articles and suggested content for users</li>
                            <li>Send newsletters, notifications, or alerts (for opted-in subscribers)</li>
                            <li>Monitor traffic patterns and audience behavior</li>
                            <li>Protect the site and users from unauthorized activity</li>
                        </ul>
                        <div className='custom-text ct-small custom-section-note'>
                            We do <strong>not share, sell, or distribute personal data</strong> to external entities.
                        </div>
                        <div className='custom-heading ch-medium'>
                            3. Cookies and Analytical Tools
                        </div>
                        <div className='custom-text ct-small'>
                            Forbes uses <strong>cookies and tracking technologies</strong> to optimize browsing, display relevant articles, and understand audience engagement. Users can manage, block, or remove cookies through their browser settings.
                        </div>
                        <div className='custom-heading ch-medium'>
                            4. Data Protection
                        </div>
                        <div className='custom-text ct-small'>
                            We employ strong <strong>security protocols and safeguards</strong> to keep your information safe from misuse, theft, or loss.
                        </div>
                        <div className='custom-heading ch-medium'>
                            5. External Resources
                        </div>
                        <div className='custom-text ct-small'>
                            Our website may include links to other platforms. Forbes is <strong>not responsible</strong> for their privacy practices, content, or accuracy. Users should review the respective policies independently.
                        </div>
                        <div className='custom-heading ch-medium'>
                            6. Policy Revisions
                        </div>
                        <div className='custom-text ct-small'>
                            This Privacy Policy may be updated occasionally to reflect new laws, technology, or internal practices. The latest version will always be available on this page.
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Privacypolicy